<div style="display: flex; float: right; flex-direction: row-reverse; padding: 2px; column-gap: 0.5em">
	<button (click)="closeWindow()" class="medium" mat-fab style="background-color: #ffffff">
		<mat-icon class="low">cancel</mat-icon>
	</button>
	<button (click)="showMarkerArea()" class="medium" mat-fab style="background-color: #ffffff">
		<mat-icon class="low">brush</mat-icon>
	</button>
	<button (click)="toggleZoom()" class="medium" mat-fab style="background-color: #ffffff">
		<mat-icon *ngIf="isZoomed" class="low">zoom_out</mat-icon>
		<mat-icon *ngIf="!isZoomed" class="low">zoom_in</mat-icon>
	</button>
</div>
<div [class.zoom]="isZoomed" class="image-container">
	<img #img [src]="image" alt="my_image" class="image" height="50%" id="myImg" width="100%"/>
</div>

